export type loggedInStatuses = 'all' | 'loggedIn' | 'notLoggedIn' | 'notLoggedInButWas' | 'loggedInOrWas';

export class LoggedInStatus {
  loggedInStatus: loggedInStatuses;

  constructor(logged_in_status: string) {
    this.loggedInStatus = this.mapLoggedInStatus(logged_in_status);
  }

  mapLoggedInStatus(value: string): loggedInStatuses {
    if (!value) {
      return <loggedInStatuses>'all';
    }

    return <loggedInStatuses>{
      'Logged in': 'loggedIn',
      'Not logged in': 'notLoggedIn',
      'Not logged in (but was logged in in the last 90 days)': 'notLoggedInButWas',
      'Logged in now or at some point in the last 90 days': 'loggedInOrWas',
    }[value];
  }

  static findCurrentStatus(isLoggedIn: boolean, wasLoggedIn: boolean): loggedInStatuses[] {
    const status: loggedInStatuses[] = ['all'];

    isLoggedIn ? status.push('loggedIn') : '';
    !isLoggedIn && !wasLoggedIn ? status.push('notLoggedIn') : '';
    isLoggedIn || wasLoggedIn ? status.push('loggedInOrWas') : '';
    !isLoggedIn && wasLoggedIn ? status.push('notLoggedInButWas') : '';

    return status;
  }
}
